var map = {
	"./Lato-Bold.ttf": 2461,
	"./Lato-Light.ttf": 2462,
	"./Lato-Regular.ttf": 2463,
	"./Poppins-Medium.ttf": 2464,
	"./Poppins-Regular.ttf": 2465,
	"./Poppins-SemiBold.ttf": 2466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 416;